import "core-js";
require("@makeleaps/ui/dist/export.css");
import { initializeSentry, PageErrorBoundary, State } from "@makeleaps/ui";
import * as Sentry from "@sentry/browser";
import { render } from "react-dom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import nestedRoutes from "./router";
import {
  attachReactShadowRoot,
  backendData,
  createReactStyleReference,
} from "./utils";
const router = createBrowserRouter([
  {
    path: "/",
    // Error displayed when routes are not correctly configured
    // If encountering this error, check makeleaps_ui/src/router.tsx to ensure you are
    // importing the correct value and that a pageRoute() exists
    errorElement: <PageErrorBoundary />,
    children: nestedRoutes,
  },
]);

async function initializeUI() {
  const reactRoot = document.getElementById("react-root");
  if (!reactRoot) throw new Error("ReactRoot not found!");
  const reactOverlays = document.getElementById("react-overlays");
  if (!reactOverlays) throw new Error("ReactOverlays not found!");

  await createReactStyleReference();

  const reactShadowRoot = await attachReactShadowRoot(reactRoot);
  const reactOverlaysWrapper = await attachReactShadowRoot(reactOverlays);
  reactOverlaysWrapper.id = "wrapper";
  reactOverlaysWrapper.className = "pointer-events-none absolute inset-0";

  const { reactdata } = backendData();
  initializeSentry(Sentry);

  render(
    <State
      data={reactdata.data}
      appPermissions={reactdata.app_permissions}
      messages={reactdata.messages}
      flags={reactdata.flags}
    >
      <RouterProvider router={router} />
    </State>,
    reactShadowRoot
  );
}

initializeUI();
